// Action Types
export const CLEAR_ERROR = 'CLEAR_ERROR_MESSAGE';

// Action Creator
export const clearError = () => {
    return {
        type: CLEAR_ERROR
    };
};
